import { CerbosOrgActions, CerbosOrgKind, CerbosTeamActions, CerbosTeamKind } from '@shared/cerbos-types';
import { buildAbacPrincipal, buildOrganizationAttributes, buildTeamAttributes } from '../abac';
import { getDecision } from '../decision';
const getTeamMemberships = (teamId, members, user)=>{
    if (!(members === null || members === void 0 ? void 0 : members.length)) {
        return [];
    }
    const member = members.find((entry)=>{
        var _entry_user;
        return ((_entry_user = entry.user) === null || _entry_user === void 0 ? void 0 : _entry_user.id) === user.id;
    });
    if (!member) {
        return [];
    }
    return [
        {
            teamId: teamId,
            role: member.role
        }
    ];
};
export const getCanManageTeam = async (organization, user, team, members)=>{
    var _ref, _ref1;
    const isTeamScoped = Boolean(team === null || team === void 0 ? void 0 : team.id);
    const action = isTeamScoped ? CerbosTeamActions.CREATE_TEAM : CerbosOrgActions.CAN_UPDATE_TEAM;
    const teamMemberships = isTeamScoped ? getTeamMemberships((_ref = team === null || team === void 0 ? void 0 : team.id) !== null && _ref !== void 0 ? _ref : '', members, user) : [];
    const decision = await getDecision({
        principal: buildAbacPrincipal(user, organization, isTeamScoped ? {
            teamMemberships
        } : undefined),
        resource: isTeamScoped ? {
            kind: CerbosTeamKind,
            id: (_ref1 = team === null || team === void 0 ? void 0 : team.id) !== null && _ref1 !== void 0 ? _ref1 : organization.id,
            attributes: buildTeamAttributes(organization, team)
        } : {
            kind: CerbosOrgKind,
            id: organization.id,
            attributes: buildOrganizationAttributes(organization)
        },
        actions: [
            action
        ]
    });
    return decision.isAllowed(action);
};
export const canMangeConfigKey = [
    'can-manage-team',
    CerbosOrgActions.CAN_UPDATE_TEAM
].join('/');
